var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconUniversityLight = function SvgIconUniversityLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_university_light_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#121619"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 32v-9.3h2.2v8.585l8.278 3.68a.7.7 0 0 0 .244 0l8.278-3.68V22.8h2.2V32a1.1 1.1 0 0 1-.653 1.005l-9 4a1.11 1.11 0 0 1-.1.039 2.801 2.801 0 0 1-1.695 0 1.11 1.11 0 0 1-.099-.039l-9-4A1.1 1.1 0 0 1 13.5 32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.978 13.236-13.733 6.07-.036.015a.139.139 0 0 0-.037.02.047.047 0 0 0-.01.012.09.09 0 0 0-.012.047c0 .023.007.04.012.047a.045.045 0 0 0 .01.012.136.136 0 0 0 .037.02l.042.018 13.725 6.166h.006a.206.206 0 0 0 .038.002c.043-.026.088-.05.135-.071l13.8-6.1a1.26 1.26 0 0 1 .036-.015.136.136 0 0 0 .037-.02.045.045 0 0 0 .01-.012.089.089 0 0 0 .012-.047.09.09 0 0 0-.012-.047.047.047 0 0 0-.01-.012.139.139 0 0 0-.037-.02 1.028 1.028 0 0 1-.036-.015l-13.733-6.07a.698.698 0 0 0-.244 0Zm-.726-2.08a2.8 2.8 0 0 1 1.696 0c.033.011.065.024.097.038l13.784 6.093c1.895.777 1.895 3.449 0 4.226l-13.714 6.062c-.64.377-1.367.334-1.863.169a1.107 1.107 0 0 1-.103-.04L9.367 21.511c-1.89-.78-1.89-3.448.004-4.225l13.784-6.093c.032-.014.064-.027.097-.038Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 31.4v-12h2.2v12H38Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_university_light_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(8 11)",
    d: "M0 0h32.2v26.2H0z"
  })))));
};
export default SvgIconUniversityLight;